import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/public/SEO";

export default function SitemapPage() {
  const [journal, setJournal] = useState([]);
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    (async () => {
      const [j, g] = await Promise.all([
        api.get("/articles?lang=tr&type=journal&page_size=200"),
        api.get("/articles?lang=tr&type=guide&page_size=200"),
      ]);
      setJournal(j.data.items || []);
      setGuides(g.data.items || []);
    })();
  }, []);

  return (
    <>
      <SEO title="Site Haritası" description="Capella Cave site haritası." />
      <section className="pt-40 pb-16 max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">Sitemap</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-none mb-8">Site Haritası</h1>
      </section>
      <section className="pb-32 max-w-5xl mx-auto px-6 md:px-10 grid md:grid-cols-3 gap-12">
        <div>
          <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-4">Genel</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="cc-link" to="/">Ana Sayfa</Link></li>
            <li><Link className="cc-link" to="/kapadokya-rehberi">Kapadokya Rehberi</Link></li>
            <li><Link className="cc-link" to="/kapadokya-gunlugu">Kapadokya Günlüğü</Link></li>
            <li><Link className="cc-link" to="/capella-cave">Capella Cave</Link></li>
            <li><Link className="cc-link" to="/kurucu-misafir-listesi">Kurucu Misafir Listesi</Link></li>
            <li><Link className="cc-link" to="/iletisim">İletişim</Link></li>
            <li><Link className="cc-link" to="/sik-sorulan-sorular">Sık Sorulan Sorular</Link></li>
            <li><Link className="cc-link" to="/arama">Arama</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-4">Kapadokya Günlüğü</div>
          <ul className="space-y-2 text-sm">
            {journal.map((a) => <li key={a.id}><Link className="cc-link" to={`/kapadokya-gunlugu/${a.translations?.tr?.slug}`}>{a.translations?.tr?.title}</Link></li>)}
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-4">Kapadokya Rehberi</div>
          <ul className="space-y-2 text-sm">
            {guides.map((a) => <li key={a.id}><Link className="cc-link" to={`/kapadokya-rehberi/${a.translations?.tr?.slug}`}>{a.translations?.tr?.title}</Link></li>)}
          </ul>
        </div>
      </section>
    </>
  );
}
